import getFQDN from '../../rest'
import LOG from '../../../logging/Logger'
import { invalidateCacheSubscription } from './subscriptionCache'

async function handlePaymentThatRequiresCustomerAction(
  stripe,
  { subscription, invoice, priceId, paymentMethodId, isRetry }
) {
  if (subscription && subscription.status === 'active') {
    // Subscription is active, no customer actions required.
    return { subscription, priceId, paymentMethodId }
  }

  // If it's a first payment attempt, the payment intent is on the subscription latest invoice.
  // If it's a retry, the payment intent will be on the invoice itself.
  const paymentIntent = invoice
    ? invoice.payment_intent
    : subscription.latest_invoice.payment_intent

  if (
    paymentIntent.status === 'requires_action' ||
    (isRetry === true && paymentIntent.status === 'requires_payment_method')
  ) {
    const result = await stripe.confirmCardPayment(
      paymentIntent.client_secret,
      {
        payment_method: paymentMethodId
      }
    )

    LOG.debug('confirmCardPayment result:', result)

    if (result.error) {
      // Start code flow to handle updating the payment details.
      // Display error message in your UI.
      // The card was declined (i.e. insufficient funds, card has expired, etc).
      LOG.error('handlePaymentThatRequiresCustomerAction error:', result.error)
      throw result.error
    } else if (result.paymentIntent.status === 'succeeded') {
      // Show a success message to your customer.
      // There's a risk of the customer closing the window before the callback.
      // We recommend setting up webhook endpoints later in this guide.
      return {
        priceId: priceId,
        subscription: subscription,
        invoice: invoice,
        paymentMethodId: paymentMethodId
      }
    }
  } else {
    // No customer action needed.
    return { subscription, priceId, paymentMethodId }
  }
}

// function handleRequiresPaymentMethod({
//   subscription,
//   paymentMethodId,
//   priceId
// }) {}

export async function createSubscription(
  stripe,
  { customerId, paymentMethodId, priceId },
  handleSuccessfulSubscription,
  handleSubscriptionError
) {
  try {
    LOG.info('about to create subscription')
    LOG.debug('customerId: ', customerId)
    LOG.debug('paymentMethodId: ', paymentMethodId)
    LOG.debug('priceId: ', priceId)
    const createSubResult = await fetch(getFQDN('v1/create-subscription'), {
      method: 'post',
      headers: {
        'Content-type': 'application/json'
      },
      body: JSON.stringify({
        customerId: customerId,
        paymentMethodId: paymentMethodId,
        priceId: priceId
      })
    })

    LOG.debug('fetch result:', createSubResult)
    const stripeSubscription = await createSubResult.json()
    LOG.debug('subsciption result:', stripeSubscription)

    // If the card is declined, display an error to the user.
    if (stripeSubscription.error) {
      // The card had an error when trying to attach it to a customer.
      return handleSubscriptionError(stripeSubscription)
    }

    // Normalize the result to contain the object returned by Stripe.
    // Add the additional details we need.
    const normalised = {
      paymentMethodId: paymentMethodId,
      priceId: priceId,
      subscription: stripeSubscription.subscription
    }
    // Some payment methods require a customer to be on session
    // to complete the payment process. Check the status of the
    // payment intent to handle these actions.
    await handlePaymentThatRequiresCustomerAction(stripe, normalised)

    // If attaching this card to a Customer object succeeds,
    // but attempts to charge the customer fail, you
    // get a requires_payment_method error.
    //handleRequiresPaymentMethod()

    // No more actions required. Provision your service for the user.
    handleSuccessfulSubscription(normalised)
    invalidateCacheSubscription()
  } catch (error) {
    LOG.error('createSubscription error:', error)
    // An error has happened. Display the failure to the user here.
    // We utilize the HTML element we created.
    handleSubscriptionError(error)
  }
}

export default createSubscription
